export default (a, f) => f(a);
